import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';
import { COLORS } from '~/src/common/theme';
import { hideScrollbar } from '~/src/common/theme/shared-styles';

export const Container = styled.nav`
  ${hideScrollbar};
  overflow-x: auto;
`;

export const List = styled.ol`
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: start;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;

  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.ACTION_DEFAULT};

  /* Chevron de séparation */
  &[data-type='home'],
  &[data-type='family'],
  &[data-type='category'],
  &[data-type='recipe-category'],
  &[data-type='recipe-subcategory'],
  &[data-type='recipe-type'] {
    &::after {
      content: '\\e962';
      font-family: ${FONTS.ICONS};
    }
  }

  /* La famille est masquée */
  &[data-type='family'] {
    display: none;
  }

  /* Le produit/recette est en gris */
  &[data-type='recipe'],
  &[data-type='product'] {
    color: ${COLORS.NEUTRAL_DISABLED};
  }

  /* Le texte hérite de la couleur de son parent */
  & > a,
  & > span {
    color: inherit;
    white-space: nowrap;
  }
`;
